var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDefaultAvatar9 = function SvgDefaultAvatar9(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 40"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "#FED607",
    rx: 20
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#401102",
    d: "M26.25 14.5a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0ZM23.25 25c0 1-.538 1.99-2 1.99h-9.002c-1.492 0-1.998-1.002-1.998-1.99 0-3.012 3-5.01 6.499-5.01 3.499 0 6.501 2.01 6.501 5.01Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#401102",
    d: "M28.25 25c1.447 0 2-1.023 2-2 0-3.01-3.038-5-6.709-5-1.016 0-2.16.285-2.747.694-.587.408-.495.86 0 1.104 2.533 1.247 3.464 3.105 3.464 4.218 0 .634.43.984.984.984h3.008ZM19.25 16.5a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0Z"
  })));
};
export default SvgDefaultAvatar9;